import React, {useState} from 'react';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material';

import {COLORS} from '@/styles/colors';

type PasswordTextFieldProps = {
  label: string;
  password: string;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  autocomplete?: string;
  id?: string;
};

const PasswordTextField: React.FC<PasswordTextFieldProps> = ({
  label,
  password,
  setPassword,
  autocomplete,
  id,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(show => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const domId = id ?? 'outlined-adornment-password';

  return (
    <FormControl
      sx={{
        width: '100%',
        '& .MuiInputLabel-root.Mui-focused': {
          color: COLORS.ON_SURFACE_1,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: COLORS.ON_OUTLINE_LIGHT,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
          {
            borderColor: COLORS.ON_SURFACE_1,
          },
      }}
      variant="outlined">
      <InputLabel
        sx={{
          fontSize: '16px',
          transform: 'translate(16px, 16px) scale(1)',
          '&.MuiInputLabel-shrink': {
            fontSize: '14px',
            padding: '10px 0px 0px 18px',
            transform: 'translate(0, -1.5rem) scale(0.75)',
          },
        }}
        htmlFor={domId}>
        {label}
      </InputLabel>
      <OutlinedInput
        id={domId}
        style={{
          borderRadius: '10px',
          backgroundColor: 'transparent',
          height: '56px',
          fontSize: '16px',
          paddingLeft: '6px',
        }}
        type={showPassword ? 'text' : 'password'}
        value={password}
        autoComplete={autocomplete}
        onChange={e => setPassword(e.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              sx={{
                marginRight: '-6px',
              }}
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
              edge="end">
              {showPassword ? (
                <VisibilityOffOutlinedIcon
                  style={{color: COLORS.BLACK, fontSize: 25}}
                />
              ) : (
                <VisibilityOutlinedIcon
                  style={{color: COLORS.BLACK, fontSize: 25}}
                />
              )}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />
    </FormControl>
  );
};

export default PasswordTextField;
